
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { GroupSchemeScope } from '@/components/mixins/schemescope';
import { Member, MemberNextLevel } from '@/models/member';
import { NodeType } from '@/models/schemeNodeModel';
import MoveStayInClassModal from '@/components/coach/members/MoveStayInClassModal.vue';

@Component({
  components: {
    MoveStayInClassModal,
  },
  name: 'MarkMoveModal',
})
export default class MarkMoveModal extends mixins(GroupSchemeScope) {
  @Prop() public member!: Member;

  private nextLevel = '';
  private nextAvailableLevel = {} as MemberNextLevel;
  private moveInClass = false;

  created() {
    this.nextAvailableLevel = this.getNextAvailableLevel();
  }

  getNextAvailableLevel() {
    if (this.allAvailableLevels.length) {
      const currentLevel = this.getMemberCurrentLevel(this.member);
      const allAvailableLevels = this.allAvailableLevels;
      if (!currentLevel) {
        return allAvailableLevels[0];
      }
      const classLevels = this.groupLevels;
      if (classLevels) {
        const memberClassLevel = classLevels.find(l => l === currentLevel) || classLevels[0];
        const classLevelIndex = allAvailableLevels.findIndex(level => level.value === memberClassLevel);
        if (classLevelIndex !== -1) {
          return allAvailableLevels[classLevelIndex + 1] ?? allAvailableLevels[0];
        }
      }
      return allAvailableLevels[0];
    }
    return { text: this.$t('move_no_available_levels'), value: '' };
  }

  get availableLevels() {
    return this.allAvailableLevels.filter(l => l.value !== this.nextAvailableLevel.value && !l.isComplete);
  }

  get passedLevels() {
    return this.allAvailableLevels.filter(l => l.value !== this.nextAvailableLevel.value && l.isComplete);
  }

  get allAvailableLevels() {
    const sorted = this.getLevelsInOrder(Object.keys(this.member.assessments.available));
    return sorted.flatMap(nodeId => {
      const node = this.getNode(nodeId);
      if (node.t === NodeType.Level) {
        const hasLevelChildren = node.children.some(n => n.t === NodeType.Level);
        // Filters levels with children that are levels, in complete or in group levels;
        if (!hasLevelChildren) {
          return [
            {
              text: this.getNodeName(nodeId),
              value: nodeId,
              isComplete: this.member.assessments.complete[nodeId] ?? false,
            },
          ];
        }
      }
      return [];
    });
  }

  get memberName() {
    return `${this.member.firstname} ${this.member.lastname}`;
  }

  selectNextLevel(nodeId: string) {
    this.nextLevel = nodeId;
  }

  async moveMember() {
    const success = await this.$store.dispatch('groupMembers/markForMove', {
      member: this.member,
      groupId: this.groupId,
      remoteNodeId: this.nextLevel,
      stay: false,
    });
    if (success !== true) {
      this.$alert('error', this.$t('member.move_class_failed'));
    }
    this.$emit('close');
  }

  closeMoveModals() {
    this.moveInClass = false;
    this.$emit('close');
  }

  checkNextInClass(nextLevel: string) {
    const classLevels = this.groupLevels;
    if (classLevels?.includes(nextLevel)) {
      this.moveInClass = true;
    } else {
      this.moveMember();
    }
  }
}
